<template>
  <div class="flex lg:justify-center font-poppins break-words">
    <table v-if="tableData && tableData.length > 0" class="w-full border-separate border-spacing-y-1.5 px-1.5">
      <thead>
        <tr class="rounded-lg border border-white shadow-[0_0_10px_0_#00000026]">
          <th v-for="(header, index) in tableHeaders" :key="header.title" @click="sortClicked(header)"
            class="mobile:px-2 laptop:px-1 largeDesktop:px-2 py-[12px] text-[12px] font-semibold cursor-pointer" :class="{
              'rounded-l-lg': index === 0,
              'rounded-r-lg text-center': index === tableHeaders.length - 1,
              '!bg-customBlue-100 text-white': true,
            }">
            <span class="flex items-center" :class="{
              'justify-left': index === tableHeaders.length - 1,
            }">
              <span v-if="header.sort_applicable == '1'" class="max-h-5">
                <button v-if="header.sort_direction == ''" class="p-0 border-0 focus:outline-none">
                  <!-- <img src="../../assets/images/default-sort.svg" alt="Sorting Arrow" class="w-4 h-4 object-contain"> -->
                </button>
                <button v-else-if="header.sort_direction == 'ASC'" class="p-0 border-0 focus:outline-none">
                  <img src="../../assets/images/asc.svg" alt="Sorting Ascending Arrow" class="w-4 h-4 object-contain">
                </button>
                <button v-else-if="header.sort_direction == 'DESC'" class="p-0 border-0 focus:outline-none">
                  <img src="../../assets/images/desc.svg" alt="Sorting Descending Arrow" class="w-4 h-4 object-contain">
                </button>
                <button v-else class="p-0 border-0 focus:outline-none">
                  <!-- <img src="../../assets/images/default-sort.svg" alt="Sorting Arrow" class="w-4 h-4 object-contain"> -->
                </button>
              </span>
              {{ header.title }}
            </span>
          </th>
        </tr>
      </thead>
      <tbody class="bg-white text-slate-800 table-row-group space-y-2 w-full">
        <tr v-for="(item, rowIndex) in tableData" :key="rowIndex"
          class="group mt-1 transition-all duration-300 py-2 rounded-lg  shadow-[0_0_10px_0_#0000001f]"
          @click="() => $emit('itemClick', item)">
          <td v-for="(header, colIndex) in tableHeaders" :key="header.data_value"
            class="px-[8px] py-[9px] bg-white text-[14px] laptop:text-[12px] largeDesktop:text-[14px] font-normal" :class="{
              'rounded-l-lg': colIndex === 0,
              'rounded-r-lg': colIndex === tableHeaders.length - 1,
              'mobile:!min-w-[70px] mobile:!max-w-[110px] border-y border-l border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'po_invoice_id',
              'mobile:!min-w-[100px]  mobile:!max-w-[200px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'order_number',
              'mobile:!min-w-[50px]  mobile:!max-w-[300px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'service_address',
              'mobile:!min-w-[95px]  mobile:!max-w-[150px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'created_at',
              'mobile:!min-w-[95px] mobile:!max-w-[130px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'paid_date',
              'mobile:!min-w-[90px]  mobile:!max-w-[100px] border-y border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'invoice_amount',
              'mobile:!min-w-[80px] mobile:!max-w-[100px] border-y border-white border-solid group-hover:!border-customBlue-100 ': header.data_value === 'action_status',
              'mobile:!min-w-[100px] mobile:!max-w-[120px] border-y border-r border-white border-solid group-hover:!border-customBlue-100': header.data_value === 'payment_type',
            }">
            <template v-if="header.data_value === 'created_at'">
              <span>
                {{ item[header.data_value] != "-" ? $helper.formattedDate(item[header.data_value]) : '-' }}
              </span>
            </template>
            <template v-else-if="header.data_value === 'po_invoice_id'">
              <span class="underline text-[#0d6efd]" v-html="item[header.data_value]">
              </span>
            </template>
            <template v-else-if="header.data_value === 'paid_date'">
              <span>
                {{ item[header.data_value] != "-" ? $helper.formattedDate(item[header.data_value]) : '-' }}
              </span>
            </template>
            <template v-else-if="header.data_value === 'invoice_amount'">
              ${{ $helper.isEmpty(item.invoice_amount) ? '-' : $helper.formatAmount(item.invoice_amount) }}/mo

            </template>
            <template v-else-if="header.data_value === 'partner_company_logo'">
              <img :src="item[header.data_value]" alt="Partner Company Logo" class="w-12 h-12 object-contain max-h-10">
            </template>
            <template v-else-if="header.data_value === 'action_status'">
              <p v-if="item.action_status == 'Paid'"
                class="inline-block text-center py-[1px] px-[10px] text-[14px] laptop:text-[12px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#B6CE35]">
                Paid</p>
                <p v-else-if="item.action_status == 'Payment Failed'"
                class="inline-block text-center py-[1px] px-[10px] text-[14px] laptop:text-[12px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#DB2777]">
                Payment Failed</p>
              <p v-else-if="item.status_slug == 'Un-Paid'"
                class="inline-block text-center py-[1px] px-[3px] text-[14px] laptop:text-[12px] largeDesktop:text-[14px] rounded-[5px] mb-0 text-white bg-[#f00]">
                Unpaid</p>
              <p v-else>-</p>
            </template>
            <template v-else-if="header.data_value === 'action'">
              <actionDropdown :item="item" @select="(data) => select(item, data)"></actionDropdown>
            </template>
            <template v-else>
              {{ item[header.data_value] }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else
      class="flex justify-center items-center w-full text-[20px] laptop:text-[30px] min-h-[60vh] 2xl:min-h-[80vh] m-0 text-[#333333]">
      No Record Found</p>
  </div>
</template>

<script>
import actionDropdown from './purchaseActionDropdown.vue';
export default {
  props: ["tableHeaders", "tableData", "sortClicked", "isLoading"],
  components: {
    actionDropdown
  },
  methods: {
    getStatusClass(status) {
      const statusClasses = {
        'approved': '#65B741',
        'pending': '#F39C12',
        'rejected': '#D7385E',
      };
      return statusClasses[status] || 'bg-gray-500';
    },
    // getTextStatusClass(textStatus) {
    //     const textStatusClasses = {
    //         'Evaluation Completed': 'text-cyan-500',
    //         'Inspection Started': 'text-blue-500',
    //     };
    //     return textStatusClasses[textStatus];
    // }
    select(item, value) {
      this.$emit('update', item, value); // emit change if needed
    },
  }
};
</script>
